const STORAGE_KEY = 'CapacitorStorage.authToken';

class AuthTokenUtil {
  private authToken: string | null = null;

  constructor() {
    this.authToken = localStorage.getItem(STORAGE_KEY);
  }

  set(token: string) {
    this.authToken = token;
    localStorage.setItem(STORAGE_KEY, token);
  }

  get() {
    return this.authToken;
  }

  remove() {
    this.authToken = null;
    localStorage.removeItem(STORAGE_KEY);
  }
}

export default new AuthTokenUtil();
